export const formatMoney = (value: number): string => {
    if(value)
        return value.toFixed(2);
    else 
        return "";
};